// tslint:disable: no-namespace
// tslint:disable: no-internal-module
// tslint:disable: max-classes-per-file
export module SharedActions {
  export class Payment {
    public static Initialize = "PaymentInitialize";
    public static Success = "PaymentSuccess";
    public static Failure = "PaymentFailure";
  }

  export class User {
    public static RefreshProfile = "UserRefreshProfile";
  }

  export class Authentication {
    public static Login = "AuthenticationLogin";
    public static Logout = "AuthenticationLogout";
    public static ForgottenPassword = "AuthenticationForgottenPassword";
    public static CompleteForgottenPassword = "AuthenticationCompleteForgottenPassword";
    public static CompleteRegistration = "AuthenticationCompleteRegistration";
  }

  export class Errors {
    public static DisplayError = "Errors.DisplayError";
    public static NavigationError = "Errors.NavigationError";
    public static ClearError = "Errors.ClearError";
  }

  export class Router {
    public static LocationChanged = "Router.LocationChanged";
  }

  export class Messaging {
    public static SaveDraft = "MessagingSaveDraft";
    public static Send = "MessagingSend";
    public static GetForEnquiry = "MessagingGetForEnquiry";
    public static MarkAllRead = "MessagingMarkAllRead";
    public static SaveSnippet = "MessagingSaveSnippet";
  }

  export class Enquiries {
    public static GetEnquiryTerms = "EnquiriesGetEnquiryTerms";
  }
}
